import React, { useRef } from 'react'
import { useRecoilValue, useRecoilValueLoadable } from 'recoil'
import {
  resultsState,
  messagesCollaborationState
} from '../recoil/state/results'
import { useIntl } from 'react-intl'
import {
  toastShow,
  TOAST_VARIANT_WARNING,
  DataListHeader,
  Divider
} from 'mailup-web-components'
import { OrderBy, BulkActionsMenu, SelectAll } from './components'
import { isOfferLight } from 'Helpers/options'

import './Results.scss'

import evalCondition from 'Helpers/evalCondition'
import { Result } from './components/Result/Result'
import { loadingState } from '../recoil/state/page'

const Results = () => {
  const intl = useIntl()
  const results = useRecoilValue(resultsState)
  const loading = useRecoilValue(loadingState)
  const { current: conditions } = useRef({
    canDelete: evalCondition('NOT uo:NONL'),
    hideCollaboration: evalCondition(
      '(uo:COLLABORATIONS AND NOT co:COLLABORATIONS) OR (NOT uo:COLLABORATIONS AND NOT uo:GEST)'
    ) || isOfferLight(),
    collaborationEnabled: evalCondition('uo:COLLABORATIONS'),
    buyCollaboration: evalCondition(
      'NOT co:COLLABORATIONS OR (uo:GEST AND NOT uo:COLLABORATIONS )'
    )
  })

  const {
    canDelete,
    hideCollaboration,
    collaborationEnabled,
    buyCollaboration
  } = conditions

  const collaborationResult = collaborationEnabled
    ? useRecoilValueLoadable(messagesCollaborationState)
    : undefined

  if (collaborationResult && collaborationResult.state === 'hasError') {
    toastShow(
      intl.formatMessage({
        id: 'Load.ActiveRecipientSummary.CollaborationErrorLoadingData'
      }),
      TOAST_VARIANT_WARNING,
      'collaboration'
    )
  }

  const heads = [
    {
      label: <SelectAll />,
      span: 3,
      sortable: false
    },
    {
      label: '',
      span: 6,
      sortable: false
    },
    {
      label: <OrderBy />,
      span: 3,
      sortable: false,
      align: 'right'
    }
  ]

  return (
    <>
      <DataListHeader heads={heads} />
      <Divider />

      {results.items.map(item => (
        <Result
          key={`message-${item.Id}`}
          message={item}
          hideCollaboration={hideCollaboration}
          collaborationEnabled={collaborationEnabled}
          buyCollaboration={buyCollaboration}
          loading={loading}
        />
      ))}
      <div className='c-messages-list-fixed-menu'>
        <BulkActionsMenu
          resultsType={results.searchParams.type}
          canDelete={canDelete}
        />
      </div>
    </>
  )
}

export default Results
